<template>
    <div class="vrm-badge--text">
        {{ translatedText }}
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
@Component
@AngularDirective('vrm-text-badge')
export default class VrmTextBadge extends Vue {
    @Prop({ type: String, default: null }) text;
    @Prop({ type: Object, default: () => ({ key: 'common.new', fallback: 'New' }) }) i18n;

    get translatedText() {
        return (
            this.text ||
            this.$t(this.i18n.key, {
                i18nFallback: this.i18n.fallback,
            })
        );
    }
}
</script>
